var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDifferentiateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-circle--button-remove-cross-add-buttons-plus-circle-+-mathematics-math"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-circle--button-remove-cross-add-buttons-plus-circle-+-mathematics-math_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M87.875 161.75C129.228 161.75 162.75 128.228 162.75 86.875C162.75 45.5227 129.228 12 87.875 12C46.5227 12 13 45.5227 13 86.875C13 128.228 46.5227 161.75 87.875 161.75Z",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.875 52.3173V121.433",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.3174 86.875H122.433",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDifferentiateIcon);
export default __webpack_public_path__ + "static/media/differentiateIcon.c7fefd03507c68a906a0d3cccf1a2e67.svg";
export { ForwardRef as ReactComponent };